import { useContext } from 'react'
import styled from 'styled-components'

import { StoresContext } from '../provider/StoreProvider'

import { useNavigate } from '../hooks/useNavigate'

import { Wrap } from '../components/container/Wrap'
import { CenterItem } from '../components/common'
import { Button } from '../components/button'
import { Text } from '../components/text'

import { Color } from '../theme/color'

import { ReactComponent as ExclamationIcon } from '../assets/gui/exclamation_90.svg'

export function InvalidAccess() {
  const { commonStore } = useContext(StoresContext)

  const navigate = useNavigate()

  const goHome = () => {
    commonStore.setInvalidAccess(false)
    navigate('/home', { replace: true })
  }

  return (
    <Wrap>
      <Content>
        <CenterItem $direction="column" $gap={24}>
          <CenterItem $direction="column" $gap={16}>
            <ExclamationIcon />
            <Text size={24} weight={600} lineHeight={34}>
              길을 잃으신 것 같아요!
            </Text>
            <Text size={14} weight={500} lineHeight={20} color="text_secondary" $textAlign="center">
              잘못된 경로이거나 비정상적인 접근이에요.
              <br />
              홈으로 돌아가서 다시 한번 길을 찾아볼까요?
              <br />
              이용에 불편을 드려서 대단히 죄송해요.
            </Text>
          </CenterItem>
          <Button type="primary" size="small" onClick={goHome}>
            홈으로 돌아가기
          </Button>
        </CenterItem>
      </Content>
    </Wrap>
  )
}

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${Color.white};
`
